
        import { createElement as _createElement } from 'react';
import { Fragment as _Fragment } from 'react';
import _map from 'lodash-es/map';
export default function fitmentTableRT () {
    function repeatAlwaysVisibleValues1(alwaysVisibleValues, alwaysVisibleValuesIndex) {
        return [alwaysVisibleValues(function () {
                function scopeNotLast1(field, fieldIndex, value, year, yearIndex) {
                    var notLast = yearIndex < value.length - 1;
                    return [_createElement('div', {
                            'className': 'fitment-cell__inner',
                            'key': '4131'
                        }, _createElement('a', {
                            'className': 'fitment-cell__value',
                            'href': year[1]
                        }, year[0]), notLast ? _createElement('span', { 'key': '623' }, ',') : null)];
                }
                function repeatYear2(field, fieldIndex, value, year, yearIndex, notLast) {
                    return scopeNotLast1.apply(this, [
                        field,
                        fieldIndex,
                        value,
                        year,
                        yearIndex
                    ]);
                }
                function scopeValue3(field, fieldIndex) {
                    var value = this[field];
                    return _createElement('div', {
                        'className': 'fitment-cell fitment-field-' + field.toLowerCase(),
                        'key': value
                    }, this.isTitle ? [_createElement('div', { 'key': '1741' }, field)] : null, !this.isTitle && value && value !== 'Universal' ? [
                        field === 'Year' ? [_map(value, repeatYear2.bind(this, field, fieldIndex, value))] : null,
                        field !== 'Year' ? [_createElement('a', {
                                'className': 'fitment-cell__value',
                                'href': value[1],
                                'key': '7191'
                            }, value[0])] : null
                    ] : null);
                }
                function repeatField4(field, fieldIndex, value) {
                    return scopeValue3.apply(this, [
                        field,
                        fieldIndex
                    ]);
                }
                return _createElement.apply(this, [
                    'div',
                    { 'className': 'fitment-row' },
                    _map(this.fields, repeatField4.bind(this))
                ]);
            }, { count: undefined })];
    }
    function repeatInitiallyHiddenValues2(initiallyHiddenValues, initiallyHiddenValuesIndex) {
        return [initiallyHiddenValues(function () {
                function scopeNotLast1(field, fieldIndex, value, year, yearIndex) {
                    var notLast = yearIndex < value.length - 1;
                    return [_createElement('div', {
                            'className': 'fitment-cell__inner',
                            'key': '4131'
                        }, _createElement('a', {
                            'className': 'fitment-cell__value',
                            'href': year[1]
                        }, year[0]), notLast ? _createElement('span', { 'key': '623' }, ',') : null)];
                }
                function repeatYear2(field, fieldIndex, value, year, yearIndex, notLast) {
                    return scopeNotLast1.apply(this, [
                        field,
                        fieldIndex,
                        value,
                        year,
                        yearIndex
                    ]);
                }
                function scopeValue3(field, fieldIndex) {
                    var value = this[field];
                    return _createElement('div', {
                        'className': 'fitment-cell fitment-field-' + field.toLowerCase(),
                        'key': value
                    }, this.isTitle ? [_createElement('div', { 'key': '1741' }, field)] : null, !this.isTitle && value && value !== 'Universal' ? [
                        field === 'Year' ? [_map(value, repeatYear2.bind(this, field, fieldIndex, value))] : null,
                        field !== 'Year' ? [_createElement('a', {
                                'className': 'fitment-cell__value',
                                'href': value[1],
                                'key': '7191'
                            }, value[0])] : null
                    ] : null);
                }
                function repeatField4(field, fieldIndex, value) {
                    return scopeValue3.apply(this, [
                        field,
                        fieldIndex
                    ]);
                }
                return _createElement.apply(this, [
                    'div',
                    { 'className': 'fitment-row' },
                    _map(this.fields, repeatField4.bind(this))
                ]);
            }, { count: undefined })];
    }
    function repeatAlwaysVisibleValues3(alwaysVisibleValues, alwaysVisibleValuesIndex) {
        return [alwaysVisibleValues(function () {
                function scopeNotLast1(field, fieldIndex, value, year, yearIndex) {
                    var notLast = yearIndex < value.length - 1;
                    return [_createElement('div', {
                            'className': 'fitment-cell__inner',
                            'key': '4801'
                        }, _createElement('a', {
                            'className': 'fitment-cell__value',
                            'href': year[1]
                        }, year[0]), notLast ? _createElement('span', { 'key': '698' }, ',') : null)];
                }
                function repeatYear2(field, fieldIndex, value, year, yearIndex, notLast) {
                    return scopeNotLast1.apply(this, [
                        field,
                        fieldIndex,
                        value,
                        year,
                        yearIndex
                    ]);
                }
                function scopeValue3(field, fieldIndex) {
                    var value = this[field];
                    return [_createElement('div', {
                            'className': 'fitment-row',
                            'key': value
                        }, _createElement('div', { 'className': 'fitment-cell' }, field), _createElement('div', { 'className': 'fitment-cell fitment-field-' + field.toLowerCase() }, !this.isTitle && value && value !== 'Universal' ? [
                            field === 'Year' ? [_map(value, repeatYear2.bind(this, field, fieldIndex, value))] : null,
                            field !== 'Year' ? [_createElement('a', {
                                    'className': 'fitment-cell__value',
                                    'href': value[1],
                                    'key': '8101'
                                }, value[0])] : null
                        ] : null))];
                }
                function repeatField4(field, fieldIndex, value) {
                    return scopeValue3.apply(this, [
                        field,
                        fieldIndex
                    ]);
                }
                return !this.isTitle ? _createElement.apply(this, [
                    'div',
                    {
                        'className': 'fitment-table__inner-container',
                        'key': '0'
                    },
                    _map(this.fields, repeatField4.bind(this))
                ]) : null;
            }, { count: undefined })];
    }
    function repeatInitiallyHiddenValues4(initiallyHiddenValues, initiallyHiddenValuesIndex) {
        return [initiallyHiddenValues(function () {
                function scopeNotLast1(field, fieldIndex, value, year, yearIndex) {
                    var notLast = yearIndex < value.length - 1;
                    return [_createElement('div', {
                            'className': 'fitment-cell__inner',
                            'key': '4801'
                        }, _createElement('a', {
                            'className': 'fitment-cell__value',
                            'href': year[1]
                        }, year[0]), notLast ? _createElement('span', { 'key': '698' }, ',') : null)];
                }
                function repeatYear2(field, fieldIndex, value, year, yearIndex, notLast) {
                    return scopeNotLast1.apply(this, [
                        field,
                        fieldIndex,
                        value,
                        year,
                        yearIndex
                    ]);
                }
                function scopeValue3(field, fieldIndex) {
                    var value = this[field];
                    return [_createElement('div', {
                            'className': 'fitment-row',
                            'key': value
                        }, _createElement('div', { 'className': 'fitment-cell' }, field), _createElement('div', { 'className': 'fitment-cell fitment-field-' + field.toLowerCase() }, !this.isTitle && value && value !== 'Universal' ? [
                            field === 'Year' ? [_map(value, repeatYear2.bind(this, field, fieldIndex, value))] : null,
                            field !== 'Year' ? [_createElement('a', {
                                    'className': 'fitment-cell__value',
                                    'href': value[1],
                                    'key': '8101'
                                }, value[0])] : null
                        ] : null))];
                }
                function repeatField4(field, fieldIndex, value) {
                    return scopeValue3.apply(this, [
                        field,
                        fieldIndex
                    ]);
                }
                return !this.isTitle ? _createElement.apply(this, [
                    'div',
                    {
                        'className': 'fitment-table__inner-container',
                        'key': '0'
                    },
                    _map(this.fields, repeatField4.bind(this))
                ]) : null;
            }, { count: undefined })];
    }
    return _createElement('div', { 'className': 'cm_fitment-table fitment-table-container' }, this.vehicleSpecific ? _createElement('div', {
        'className': 'fitment-table-title vehicle-specific',
        'key': '58'
    }) : null, this.noFitmentData ? _createElement('div', {
        'className': 'fitment-table-title no-fitment-data',
        'key': '154'
    }, '\n    ', window.Convermax.config?.fitmentUnknownTitle || 'No Fitment Data', _createElement('br', {}), window.Convermax.config?.fitmentUnknownText || `This product doesn't have fitment application data. Please verify fitment manually.`, '\n  ') : null, this.universalFit ? _createElement('div', {
        'className': 'fitment-table-title universal-fit',
        'key': '468'
    }, '\n    ', window.Convermax.config?.verifyFitmentUniversalTitle || window.Convermax.config?.fitmentUniversalTitle || 'Universal Fit', _createElement('br', {}), window.Convermax.config?.verifyFitmentUniversalText || window.Convermax.config?.fitmentUniversalText || 'This product may require modification.', '\n  ') : null, this.manyFitments ? _createElement('div', {
        'className': 'fitment-table-title many-fitments',
        'key': '852'
    }, 'Currently displaying 1000 fitments, yet the product has additional fitments.') : null, this.template === 'horizontal' ? _createElement('div', {
        'className': 'cm_fitment-table__horizontal cmTemplate_horizontal',
        'key': '1011'
    }, _createElement.apply(this, [
        'div',
        { 'className': 'fitment-table-body cmRepeater_alwaysVisibleValues' },
        _map(this.alwaysVisibleValues, repeatAlwaysVisibleValues1.bind(this))
    ]), _createElement.apply(this, [
        'div',
        { 'className': 'fitment-table-body cm_collapsible-elem cmRepeater_initiallyHiddenValues' },
        _map(this.initiallyHiddenValues, repeatInitiallyHiddenValues2.bind(this))
    ])) : null, this.template === 'vertical' ? _createElement('div', {
        'className': 'cm_fitment-table__vertical cmTemplate_vertical',
        'key': '5024'
    }, _createElement.apply(this, [
        'div',
        { 'className': 'fitment-table-body cmRepeater_alwaysVisibleValues' },
        _map(this.alwaysVisibleValues, repeatAlwaysVisibleValues3.bind(this))
    ]), _createElement.apply(this, [
        'div',
        { 'className': 'fitment-table-body cm_collapsible-elem cmRepeater_initiallyHiddenValues' },
        _map(this.initiallyHiddenValues, repeatInitiallyHiddenValues4.bind(this))
    ])) : null, this.initiallyHiddenValues.length ? _createElement('div', {
        'className': 'cm_fitment-table_collapse-button-container',
        'key': '9338'
    }, _createElement('button', {
        'className': 'cm_fitment-table_collapse-button btn btn--primary',
        'onClick': this.toggleCollapsed
    }, this.isCollapsed ? ['Show More'] : null, !this.isCollapsed ? ['Show Less'] : null)) : null);
}
        export const componentNames = []